import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { TrButton } from '@skytech/ui/Table/TrButton'

import { Translation } from '@/app/translations/Translation'
import Highlight from '@/components/Highlight'
import RouterLink from '@/components/RouterLink'
import { useIsAdmin } from '@/hooks/access'
import { useLocalDateTime } from '@/hooks/use-local-date-time'
import { APP_ROUTES } from '@/util/app-routes'

import type { EmployeeConsentDetails } from '../../resources'

type EmployeeListItemProps = EmployeeConsentDetails['eligibleCostObjects'][number] & {
  searchFilter: string
  openModal: (id: number) => void
}

export const EmployeeListItem: FC<EmployeeListItemProps> = ({
  id,
  name,
  department,
  code,
  approvedDate,
  revokedDate,
  email,
  employeeNo,
  searchFilter,
  openModal,
}) => {
  const { formatTime } = useLocalDateTime()

  const onClick = () => {
    if (!approvedDate && !revokedDate) return

    openModal(id)
  }

  return (
    <TrButton onClick={onClick}>
      <Td>
        <CostObjectName id={id} name={name} searchFilter={searchFilter} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={formatTime({ date: approvedDate })} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={formatTime({ date: revokedDate })} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={employeeNo} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={code} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={email} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={department} />
      </Td>
    </TrButton>
  )
}

type CostObjectNameProps = {
  searchFilter: string
  id: number
  name: string
}

const CostObjectName: FC<CostObjectNameProps> = ({ searchFilter, id, name }) => {
  const isAdmin = useIsAdmin()

  if (name === 'Expired') return <Translation id="User unavailable" />

  if (isAdmin) {
    return (
      <RouterLink
        to={APP_ROUTES.EMPLOYEE.replace(':costObjectId', String(id))}
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <Highlight pattern={searchFilter} text={name} />
      </RouterLink>
    )
  }
  return <Highlight pattern={searchFilter} text={name} />
}
